import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { translate } from 'shared/utils/translate';
import { Container } from 'components/shared/container/Container.styled';
import { SectionFlattenProps } from '../section/Section.props';
import * as Styled from './FeaturedTrips.styled';

const FeaturedTrips = ({
  components,
  intl,
}: WrappedComponentProps & SectionFlattenProps) => (
  <Container>
    <Styled.ImageGrid>
      {components?.map(component => (
        <Styled.ImageGridItem
          itemsLength={components.length}
          key={component.id}
        >
          <Styled.ImageGridLink
            href={component.url}
            title={translate({ intl, id: component.title })}
            imageUrl={component.imageUrl}
            target="_blank"
            rel="noreferrer noopener"
          >
            <Styled.ImageLabel>
              {translate({ intl, id: component.title })}
            </Styled.ImageLabel>
          </Styled.ImageGridLink>
        </Styled.ImageGridItem>
      ))}
    </Styled.ImageGrid>
  </Container>
);

export default injectIntl(FeaturedTrips);
